import { render } from "./LetsTalkSection.vue?vue&type=template&id=7d68e260&scoped=true"
import script from "./LetsTalkSection.vue?vue&type=script&lang=js"
export * from "./LetsTalkSection.vue?vue&type=script&lang=js"

import "./LetsTalkSection.vue?vue&type=style&index=0&id=7d68e260&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d68e260"]])

export default __exports__